// extracted by mini-css-extract-plugin
export var chevron = "_cv-4";
export var chevronExpanded = "_cv-5";
export var row = "_cv-0";
export var rowBody = "_cv-6";
export var rowDescription = "_cv-7";
export var rowHeader = "_cv-1";
export var rowTitle = "_cv-2";
export var rowTitleComplete = "_cv-3";